/**
 * Last-fetched `user_notice_receipts` rows (RD-NOTICES-V2), for a consumer
 * that mounts AFTER `NoticeReceiptsSync`'s hydration already ran — the AI Hub
 * tab, for instance, is not on screen at sign-in, so its alerts feed cannot
 * rely on being present for the hydration merge. Populated once per
 * hydration (see `NoticeReceiptsSync`); a late consumer reads it once on
 * mount, then relies on the live bus for anything after that.
 *
 * Module-level and session-scoped by construction: `NoticeReceiptsSync`
 * clears it on unmount (sign-out), same discipline as the session module.
 */

let lastFetchedRows = [];

export function setLastFetchedNoticeReceipts(rows) {
  lastFetchedRows = Array.isArray(rows) ? rows : [];
}

export function getLastFetchedNoticeReceipts() {
  return lastFetchedRows;
}

export function clearLastFetchedNoticeReceipts() {
  lastFetchedRows = [];
}
